import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {InputMask} from "primereact/inputmask";
import moment, { now } from "moment/moment";
import {Calendar} from "primereact/calendar";
import {Panel} from "primereact/panel";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputNumber} from "primereact/inputnumber";
import {AutoComplete} from "primereact/autocomplete";
import download from 'js-file-download';

const PurchaseorderInventorydocumentFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [loadingItems, setLoadingItems] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [dateInputKey, setDateInputKey] = useState(0);
  const [formData, setFormData] = useState({
    date: null,
    // items: [],
    purchase_orders: [Number(id)]
  });
  const [newFormData, setNewFormData] = useState({});
  const [warehouses, setWarehouses] = useState([]);
  const [warehouseLocations, setWarehouseLocations] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [items, setItems] = useState([]);

  const [totalRecordsItems, setTotalRecordsItems] = useState(0);
  const [rowsItems, setRowsItems] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dtItems = useRef(null);
  const selectedWarehouseId = formData?.warehouse_to?.id || formData?.warehouse_to || null;
  const selectedWarehouse = warehouses.find(
    item => item.id === selectedWarehouseId
  );
  const showWarehouseLocationToColumn = !!selectedWarehouse?.warehouse_location_required;
  const [lazyParamsItems, setLazyParamsItems] = useState({
    first: 0,
    rows: rowsItems,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
    filters: {
      inventory_document: {value: window.App.urlVars().inventoryDocumentId, matchMode: 'equals'}
    }
  });
  const purchaseorderSupplierId = window.App.urlVars().purchaseorderSupplierId ? Number(window.App.urlVars().purchaseorderSupplierId) : null;

  const [partners, setPartners] = useState([]);
  const [partnerDisplayValue, setPartnerDisplayValue] = useState('');
  const [company, setCompany] = useState([]);

  const [deliveryNoteFile, setDeliveryNoteFile] = useState(null);
  const [deliveryNoteFileId, setDeliveryNoteFileId] = useState(null);
  const [uploadingFile, setUploadingFile] = useState(false);

  // const hasFile = !!(formData.file || deliveryNoteFileId);

  const isExisting = !!(formData.id || window.App.urlVars().inventoryDocumentId);
  const deliveryFileInputRef = useRef(null);
  const hasSavedFile = !!(isExisting && formData.file && !deliveryNoteFileId);

  let loadLazyTimeoutItems = null;
  const loadLazyDataItems = () => {
    setLoadingItems(true);
    if (loadLazyTimeoutItems) {
      clearTimeout(loadLazyTimeoutItems);
    }
    loadLazyTimeoutItems = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParamsItems)
      apiCall('GET', '/api/v2/inventory-document-item' + query)
        .then(response => {
          setTotalRecordsItems(response.data.data.total_item_count);
          setItems(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoadingItems(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPageItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    setLazyParamsItems(_lazyParams);
  }
  const onSortItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    setLazyParamsItems(_lazyParams);
  }
  const onFilterItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParamsItems(_lazyParams);
  }
  const pagerItems = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRowsItems(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    // const payload = {
    //   ...data,
    //   file: deliveryNoteFileId ?? formData.file ?? null,
    //   purchase_orders: formData.purchase_orders ?? [Number(id)],
    // };
    const payload = {
      date: moment(formData.date),
      warehouse_to: formData?.warehouse_to?.id || formData.warehouse_to,
      partner: formData.partner,
      company: formData.company?.id || formData.company,
      description: formData.description,
      documentNumber: formData.document_number, 
      file: deliveryNoteFileId
        ?? (typeof formData.file === 'object' ? formData.file?.id : formData.file)
        ?? null,
    };
    if (window.App.urlVars().inventoryDocumentId || formData.id) {
      apiCall('patch', '/api/v2/inventory-document/' + props.entity + "/" + window.App.urlVars().inventoryDocumentId, { 
        ...newFormData, file: payload.file,
        //  purchase_orders: payload.purchase_orders 
      })
        .then(response => {
          const saved = response.data.data;
          window.App.toastShow('success', 'Sikeres befejezés!');
          window.App.setState({ rerenderPurchaseorderInventorydocumentList: Math.random() });
          setFormData(saved);
          setNewFormData(saved);
          setDeliveryNoteFile(null);
          setDeliveryNoteFileId(null);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/inventory-document/' + props.entity, payload)
        .then(async response => {
          const saved = response.data.data;
          try {
            if (purchaseorderSupplierId && saved?.id) {
              await apiCall(
                'put',
                `/api/v2/inventory-document/transfer-supplier/${saved.id}/purchase-order-supplier/${purchaseorderSupplierId}`,
                {}
              );
              const itemsQuery =
                `?search[inventory_document][operator]=%3D` +
                `&search[inventory_document][value]=${saved.id}` +
                `&rows=${rowsItems}`;

              const itemsRes = await apiCall(
                'GET',
                '/api/v2/inventory-document-item' + itemsQuery
              );
              setTotalRecordsItems(itemsRes.data.data.total_item_count);
              setItems(itemsRes.data.data.items);
              setLazyParamsItems(prev => ({
                ...prev,
                first: 0,
                page: 0,
                filters: {
                  ...(prev.filters || {}),
                  inventory_document: { value: saved.id, matchMode: 'equals' }
                }
              }));
            }
          } catch (error) {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        }
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({ rerenderPurchaseorderInventorydocumentList: Math.random() });

          setFormData(saved);
          setNewFormData(saved);
          // setItems(saved.items || []);
          setDeliveryNoteFile(null);
          setDeliveryNoteFileId(null);

          if (props.goback === true) {
            history.push(-1);
          } else {
            history.push(
              '/procurement/purchase-order/' +
                action + '/' + id +
                '?update=inventorydocument&inventoryDocumentId=' +
                saved.id + '&type=transfer-supplier'
            );
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const renderErrorText = (error) => {
    if (!error) return null;
    if (typeof error === 'string') return error;
    if (Array.isArray(error)) {
      return error.map(item => {
        if (typeof item === 'string') return item;
        if (item?.message) return item.message;
        try {
          return JSON.stringify(item);
        } catch {
          return 'Hibás érték';
        }
      }).join(', ');
    }
    if (error?.message) return error.message;
    try {
      return JSON.stringify(error);
    } catch {
      return 'Hibás érték';
    }
  };

  const getFormErrorMessage = (meta) => {
    const errorText = isFormFieldValid(meta) ? renderErrorText(meta.error) : null;
    return errorText ? <small className="p-error">{errorText}</small> : null;
  };

  const normalizeErrorMessage = (errorValue, fallback = 'Hiba történt') => {
    if (!errorValue) return fallback;
    if (typeof errorValue === 'string') return errorValue;
    if (Array.isArray(errorValue)) {
      const first = errorValue[0];
      if (typeof first === 'string') return first;
      if (first?.message) return first.message;
      try {
        return JSON.stringify(first);
      } catch {
        return fallback;
      }
    }
    if (errorValue?.message) return errorValue.message;
    try {
      return JSON.stringify(errorValue);
    } catch {
      return fallback;
    }
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    if (formData.status === 'COMPLETED') {
      return null;
    }
    return (
      <React.Fragment>
        <Button
          type="button"
          icon="pi pi-trash"
          className="p-button-danger p-button-sm"
          tooltip="Tétel törlése"
          tooltipOptions={{position: 'left'}}
          onClick={() => deleteInventoryItem(rowData)}
        />
      </React.Fragment>
    );
  };

  const uploadDeliveryNoteFile = async (file) => {
    if (!file) return;
    setUploadingFile(true);

    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await apiCall("post", "/api/v2/file/upload", fd);
      const id = res?.data?.data?.id;
      setDeliveryNoteFileId(id);
      setFormData((prev) => ({ ...prev, file: id }));
      setNewFormData((prev) => ({ ...prev, file: id }));
      window.App.toastShow("success", "Fájl feltöltve!");
    } catch (err) {
      window.App.toastShow("error", t("error"), err.toString(), "", err.response);
    } finally {
      setUploadingFile(false);
    }
  };

  const downloadDeliveryNoteFile = async () => {
    const fileId = formData?.file?.id ?? formData.file ?? deliveryNoteFileId;
    setUploadingFile(true);
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_HOST + '/api/v2/file/' + fileId + '/download',
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('userToken'),
            'App-Network': localStorage.getItem('networkId'),
          },
        }
      );
      const filename =
        formData?.file?.filename || deliveryNoteFile?.name;
      download(res.data, filename);
    } catch (err) {
      window.App.toastShow('error', t('error'), err.toString(), '', err.response);
    } finally {
      setUploadingFile(false);
    }
  };

  const deleteInventoryItem = (rowData) => {
    if (!rowData?.id) return;
    if (formData.status === 'COMPLETED') return;
    if (!window.confirm('Biztosan törölni szeretnéd ezt a tételt?')) {
      return;
    }
    setLoadingItems(true);
    apiCall('delete', '/api/v2/inventory-document-item/' + rowData.id)
      .then(() => {
        window.App.toastShow('success', 'Tétel sikeresen törölve!');
        setItems(prev => prev.filter(item => item.id !== rowData.id));
        setTotalRecordsItems(prev => Math.max(0, prev - 1));
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoadingItems(false);
      });
  };

  const updateInventoryItemField = (rowId, fieldName, value) => {
    const key = `${rowId}_${fieldName}`;
    const el = document.getElementById(`${fieldName}_${rowId}`);
    const target = el?.querySelector('.p-inputtext') || el;
    if (target) target.style.background = "#ffc107";
    if (target) target.style.color = "white";
    if (!rowId) return;
    if (!window.inventoryItemTimeout) window.inventoryItemTimeout = {};
    if (!window.inventoryItemErrorShown) window.inventoryItemErrorShown = {};
    if (!window.inventoryItemRequestId) window.inventoryItemRequestId = {};
    if (window.inventoryItemTimeout[key]) {
      clearTimeout(window.inventoryItemTimeout[key]);
    }
    window.inventoryItemTimeout[key] = setTimeout(() => {
      const requestId = Date.now() + Math.random();
      window.inventoryItemRequestId[key] = requestId;
      apiCall('patch', `/api/v2/inventory-document-item/transfer-supplier/${rowId}`, {
        [fieldName]: value
      })
        .then(() => {
          if (window.inventoryItemRequestId[key] !== requestId) return;
          if (target) target.style.background = "#28a745";
          if (target) target.style.color = "white";
          setFieldErrors(prev => ({ ...prev, [key]: '' }));
          window.inventoryItemErrorShown[key] = false;
        })
        .catch((error) => {
          if (window.inventoryItemRequestId[key] !== requestId) return;
          if (target) target.style.background = "red";
          if (target) target.style.color = "white";
          const backendErrors = error?.response?.data?.data || {};
          const rawError = backendErrors[fieldName] || error?.response?.data?.message || error;
          const msg = normalizeErrorMessage(rawError, error.toString());
          setFieldErrors(prev => ({ ...prev, [key]: msg }));
          if (!window.inventoryItemErrorShown[key]) {
            window.App.toastShow("error", t("error"), msg, "", error.response);
            window.inventoryItemErrorShown[key] = true;
          }
        });
    }, 400);
  };

  const searchPartner = (event) => {
    const q = (event?.query || '').trim();
    if (q.length < 2) {
      setPartners([]);
      return;
    }
    setLoading(true);
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/api/v2/partner?rows=15" +
      "&search[name][operator]=like" +
      "&search[name][value]=" + encodeURIComponent('%' + q + '%'),
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "App-Network": localStorage.getItem("networkId"),
          },
        }
      )
      .then((response) => {
        const list = response?.data?.data?.items ?? [];
        const mapped = list.map((p) => ({
          ...p,
          name:
            p.name +
            (p.addressPostalCode || p.addressCity || p.addressDetail
              ? ` (${p.addressPostalCode ?? ""} ${p.addressCity ?? ""}, ${p.addressDetail ?? ""})`
              : ""),
        }));
        setPartners(mapped);
      })
      .catch((error) => {
        window.App.toastShow("error", t("error"), error.toString(), "", error.response);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const urlVars = window.App.urlVars();
    if (urlVars.partnerName) {
      const decodedName = decodeURIComponent(urlVars.partnerName);
      setPartnerDisplayValue(decodedName);
      setFormData((prev) => ({ ...prev, partner: Number(urlVars.partnerId) || null }));

      setNewFormData((prev) => ({ ...prev, partner: Number(urlVars.partnerId) || null }) );
    }
  }, [window.App.urlVars().partnerName]);


  useEffect(() => {
    if (window.App.urlVars().inventoryDocumentId) {
      loadLazyDataItems()
    }
  }, [lazyParamsItems])

  // useEffect(() => {
  //   if (formData.warehouse_to) {
  //     apiCall('GET', '/api/v2/warehouse-location?search[warehouse][operator]==&search[warehouse][value]=' + formData?.warehouse_to?.id + '&search[type][operator]==&search[type][value]=PICK')
  //       .then(response => {
  //         setWarehouseLocations(response.data.data.items)
  //       })
  //       .catch(error => {
  //         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //       })
  //   }
  // }, [formData.warehouse_to])

  useEffect(() => {
    apiCall('GET', '/api/v2/warehouse')
      .then(response => {
        setWarehouses(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (id && !window.App.urlVars().create) {
      setLoading(true);
      apiCall('get', '/api/v2/inventory-document/' + window.App.urlVars().inventoryDocumentId)
        .then(response => {
          setFormData(response.data.data);
          setNewFormData(response.data.data);
          if (response?.data?.data?.partner?.name) {
            setPartnerDisplayValue(response.data.data.partner.name);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  useEffect(() => {
    const wid = formData?.warehouse_to?.id || formData?.warehouse_to;
    const warehouse = warehouses.find(item => item.id === wid);
    if (!wid || !warehouse?.warehouse_location_required) {
      setWarehouseLocations([]);
      return;
    }
    apiCall(
      'GET',
      '/api/v2/warehouse-location' +
        '?search[warehouse][operator]==&search[warehouse][value]=' + wid +
        '&search[type][operator]==&search[type][value]=PICK'
    )
      .then(response => setWarehouseLocations(response.data.data.items))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));
  }, [formData.warehouse_to, warehouses]);

  useEffect(() => {
    const isCreate = !window.App.urlVars().inventoryDocumentId && !formData.id;
    if (!isCreate || !id || formData.warehouse_to) return;
    (async () => {
      try {
        const poRes = await apiCall('get', `/api/v2/purchase-order/${id}`);
        const projectId = poRes?.data?.data?.project?.id;
        if (!projectId) return;
        const prRes = await apiCall('get', `/api/v2/project/${projectId}`);
        const wid = prRes?.data?.data?.warehouse?.id ?? prRes?.data?.data?.warehouse ?? null;
        if (!wid) return;
        setFormData(p => ({ ...p, warehouse_to: wid }));
        setNewFormData(p => ({ ...p, warehouse_to: wid }));
      } catch (error) {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      }
    })();
  }, [id]);

  useEffect(() => {
    apiCall('GET', '/api/v2/company')
      .then((response) => {
        const items = response?.data?.data?.items ?? [];
        setCompany(items);

        if (!formData.company && items.length === 1) {
          setFormData((prev) => ({ ...prev, company: items[0].id }));
          setNewFormData((prev) => ({ ...prev, company: items[0].id }));
        }
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []); 

  return (
    <div className={"inventorydocument-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData} enableReinitialize
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="date" render={({input, meta}) => (
                <span className="p-field p-fluid">
                    <label htmlFor="date"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldFulfillmentDateTime')}</label>
                    <div className="p-inputgroup calendar-icon-only">
                            <InputMask
                                      key={dateInputKey}
                                      id={"date"}
                                       disabled={formData.status && formData.status !== 'DRAFT'}
                                       mask={"9999-99-99"}
                                       placeholder={t('datePlaceholder')}
                                       value={formData.date ? moment(formData.date).format('YYYY-MM-DD') : ''}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           const selectedDate = moment(e.value, 'YYYY-MM-DD', true);
                                            if (!selectedDate.isValid()) {
                                              return;
                                            }
                                            if (selectedDate.isAfter(moment(), 'day')) {
                                              const today = moment().startOf('day').toDate();
                                              setFormData({
                                                ...formData,
                                                date: today
                                              });
                                              setNewFormData({
                                                ...newFormData,
                                                date: today
                                              });
                                              setDateInputKey(dateInputKey + 1);
                                              return;
                                            }
                                            setFormData({
                                              ...formData,
                                              date: selectedDate.toDate()
                                            });
                                            setNewFormData({
                                              ...newFormData,
                                              date: selectedDate.toDate()
                                            });
                                         }
                                       }}
                            />
                            <Calendar value={formData.date}
                                      locale="hu"
                                      disabled={formData.status && formData.status !== 'DRAFT'}
                                      dateFormat={'yy-mm-dd'}
                                      showIcon
                                      maxDate={new Date()}
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          date: e.value
                                        })
                                        setNewFormData({
                                          ...newFormData,
                                          date: e.value
                                        })
                                      }}/>
                    </div>
                  {getFormErrorMessage(meta)}
                  </span>
              )}/>
            </div>
            {/* <div className={"p-col-12 p-lg-4"}>
              <Field name="warehouse_to" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="warehouse_to"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldWarehouseTo')}</label>
                  <span className={"p-d-block"}>
                              <Dropdown {...input}
                                        disabled={formData.status && formData.status !== 'DRAFT'}
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            warehouse_to: e.target.value
                                          })
                                          setNewFormData({
                                            ...newFormData,
                                            warehouse_to: e.target.value
                                          })
                                        }}
                                        value={formData?.warehouse_to?.id || formData.warehouse_to}
                                        options={window.App.sortDropdownOptions(warehouses, "name")}
                                        optionLabel="name"
                                        optionValue="id"
                                        id={"warehouse_to"}
                                        emptyMessage={t('noWarehouseYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div> */}
            <div className="p-col-12 p-lg-4">
              <Field
                name="partner"
                render={({ input, meta }) => (
                  <div className="p-field p-fluid">
                    <label
                      htmlFor="partner"
                      className={classNames({ "p-error": isFormFieldValid(meta) })}
                    >{props.t('fieldPartner')}</label>

                    <span className="p-inputgroup">
                      <Button
                        type="button"
                        className="p-button"
                        onClick={() => {
                          let _params = "?";
                          Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                            _params += key + "=" + value + "&";
                          });
                          _params += "search=partner";
                          history.push(window.location.hash.replace("#", "") + _params);
                        }}
                        disabled={formData.status && formData.status !== "DRAFT"}
                      >
                        <i className="pi pi-search"></i>
                      </Button>

                      <AutoComplete
                        id="partner"
                        value={partnerDisplayValue}
                        suggestions={partners}
                        completeMethod={searchPartner}
                        field="name"
                        delay={700}
                        forceSelection={false}
                        placeholder={t('typeToSearchPlaceholderEllipsis')}className={classNames({ "p-invalid": isFormFieldValid(meta) })}
                        onSelect={(e) => {
                          const selectedPartner = e.value;
                          setPartnerDisplayValue(selectedPartner.name);
                          input.onChange(selectedPartner.id); 
                          setFormData(prev => ({ ...prev, partner: selectedPartner.id }));
                          setNewFormData(prev => ({ ...prev, partner: selectedPartner.id }));
                        }}
                        onChange={(e) => {
                          setPartnerDisplayValue(e.value);
                          if (e.value === null || e.value === '') {
                            input.onChange(null);
                            setFormData(prev => ({ ...prev, partner: null }));
                            setNewFormData(prev => ({ ...prev, partner: null }));
                          }
                        }}
                        onBlur={() => {
                          if (!partnerDisplayValue && input.value) {
                            input.onChange(null);
                          }
                        }}
                        disabled={formData.status && formData.status !== "DRAFT"}
                      />
                    </span>

                    {getFormErrorMessage(meta)}
                  </div>
                )}
              />
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="company" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="company" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCompany')}</label>
                  <span className="p-d-block">
                    <Dropdown
                      id="company"
                      options={window.App.sortDropdownOptions(company, "name")}
                      optionValue="id"
                      optionLabel="name"
                      value={formData.company?.id || formData.company || null}
                      emptyMessage={t('noCompanyYet')}
                      onChange={(e) => {
                        setFormData({ ...formData, company: e.value });
                        setNewFormData({ ...newFormData, company: e.value });
                      }}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-12"}>
              <Field name="description" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="description"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDescription')}</label>
                  <span className="p-d-block">
                      <InputText id="description" {...input}
                                 disabled={formData.status && formData.status !== 'DRAFT'}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     description: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     description: e.target.value
                                   })
                                 }}
                                 value={formData.description}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {props.entity === 'transfer-supplier' &&
              <div className={"p-col-12 p-lg-4"}>
                <Field name="document_number" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="document_number"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDocumentNumber')}</label>
                    <span className="p-d-block">
                      <InputText id="document_number" {...input}
                                 disabled={formData.status && formData.status !== 'DRAFT'}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     document_number: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     document_number: e.target.value
                                   })
                                 }}
                                 value={formData.document_number}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }
            {props.entity === 'transfer-supplier' && (
              <div className="p-col-12 p-lg-8">
                <div className="p-field">
                  <label>
                    {hasSavedFile ? props.t('downloadDeliveryNote') : props.t('uploadDeliveryNote')}
                  </label>
                  <div>
                    <input
                      type="file"
                      ref={deliveryFileInputRef}
                      style={{ display: 'none' }}
                      onChange={(e) => {
                        const f = e.target.files?.[0];
                        if (f) {
                          setDeliveryNoteFile(f);
                          uploadDeliveryNoteFile(f);
                        }
                        e.target.value = null;
                      }}
                      disabled={
                        uploadingFile ||
                        (formData.status && formData.status !== 'DRAFT')
                      }
                    />
                    {!hasSavedFile && (
                      <Button
                        type="button"
                        className="p-button p-ml-2"
                        onClick={() => {
                          if (
                            !uploadingFile &&
                            (!formData.status || formData.status === 'DRAFT')
                          ) {
                            deliveryFileInputRef.current?.click();
                          }
                        }}
                        disabled={
                          uploadingFile ||
                          (formData.status && formData.status !== 'DRAFT')
                        }
                      >
                        <i className="pi pi-plus" />
                        &nbsp;
                        {uploadingFile
                          ? props.t('uploading')
                          : (deliveryNoteFile?.name || props.t('chooseFile'))}
                      </Button>
                    )}
                    {hasSavedFile && (
                      <Button
                        type="button"
                        icon="pi pi-download"
                        className="p-button-secondary"
                        onClick={downloadDeliveryNoteFile}
                        disabled={uploadingFile}
                        tooltip={props.t('downloadDeliveryNote')}
                        tooltipOptions={{ position: 'left' }}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
            </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {window.App.urlVars().inventoryDocumentId &&
                <Button type="button" label={props.t('closeDeliveryNote')}
                        loading={loading}
                        icon={"pi pi-lock"}
                        disabled={formData.status === 'COMPLETED' || !items?.length}
                        onClick={() => {
                          apiCall('post', '/api/v2/inventory-document/' + props.entity + '/' + window.App.urlVars().inventoryDocumentId + '/complete', {})
                            .then(response => {
                              window.App.toastShow('success', 'Sikeres befejezés!');
                              window.App.setState({rerenderPurchaseorderInventorydocumentList: Math.random()})
                              setFormData(response.data.data)
                            })
                            .catch(error => {
                              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                            })
                            .finally(() => {
                              setLoading(false);
                            })
                        }}
                        className="p-button-warning p-mr-2"/>
              }
              <Button type="submit" label={t('save')}
                      loading={loading}
                      disabled={formData.status && formData.status !== 'DRAFT'}
                      icon={"pi pi-save"}
                      className="p-button-success p-ml-2"/>
              {/* <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      disabled={formData.status && formData.status !== 'DRAFT'}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/> */}
            </div>
          </div>

          {window.App.urlVars().inventoryDocumentId &&
            <>
              <Panel className={"p-mt-3"}>
                <h4 className={"p-mt-0"}>Átvett termékek</h4>
                <DataTable
                  emptyMessage={t('noResults')}
                  size={"small"}
                  loading={loadingItems}
                  value={items} paginator first={lazyParamsItems.first} totalRecords={totalRecordsItems}
                  onPage={onPageItems}
                  onSort={onSortItems} sortField={lazyParamsItems.sortField} sortOrder={lazyParamsItems.sortOrder}
                  onFilter={onFilterItems} filters={lazyParamsItems.filters} lazy
                  paginatorTemplate={pagerItems} rows={rowsItems}
                  autoLayout={true}
                  filterDisplay="row"
                  responsiveLayout="scroll"
                  stripedRows
                  ref={dtItems}
                  dataKey="id"
                >
                  <Column header={t('columnName')} sortable filter
                          body={(rowData) => {
                            if (formData.id) {
                              return (
                                <>
                                  {rowData?.material?.name}
                                </>
                              )
                            } else {
                              let material = materials.find(item => item.id === rowData.material)
                              return (
                                <>
                                  {material.name || material?.material?.name}
                                </>
                              )
                            }
                          }}
                  ></Column>
                  <Column header={t('upc')} field={"material.upc"}></Column>
                  {showWarehouseLocationToColumn && (
                  <Column header={t('columnTargetWarehouseLocation')} body={(rowData) => {
                    const key = `${rowData.id}_warehouse_location_to`;
                    return (
                      <div className="p-field">
                      <Dropdown
                        id={'warehouse_location_to_' + rowData.id}
                        onChange={(e) => {
                          const val = e.value;
                          setItems(prev => prev.map(item => item.id === rowData.id ? { ...item, warehouse_location_to: val } : item));
                          updateInventoryItemField(rowData.id, 'warehouse_location_to', val);
                        }}
                        placeholder={rowData?.warehouse_location_to?.code}
                        value={rowData?.warehouse_location_to?.id || rowData?.warehouse_location_to || null}
                        options={window.App.sortDropdownOptions(warehouseLocations, "code")}
                        optionLabel="code"
                        optionValue="id"
                        emptyMessage={t('noLocationYet')}
                        className={classNames({"p-inputtext-sm": true, "p-invalid": !!fieldErrors[key]})}
                      />
                      <div className="p-error p-d-block" style={{ minHeight: '1rem' }}>
                        {renderErrorText(fieldErrors[key]) || ''}
                      </div>
                    </div>
                  )
                }}></Column>
                )}
                {items.some(item => !!item?.purchase_order_supplier_item) && (
                  <Column header="Megrendelve"
                    body={(rowData) => {
                      const quantity = rowData?.purchase_order_supplier_item?.quantity;
                      const unit = rowData?.purchase_order_supplier_item?.unit?.name;
                      if (quantity === null || quantity === undefined) {
                        return '';
                      }
                      return unit ? `${quantity} ${unit}` : quantity;
                    }}
                  />
                )}
                  <Column field="quantity" header={t('columnQuantity')} sortable filter
                        body={(rowData) => {
                          const key = `${rowData.id}_quantity`;
                          return (
                            <div style={{ overflow: 'visible' }}>
                              <InputNumber
                                minFractionDigits={0}
                                maxFractionDigits={9}
                                locale="hu-HU"
                                id={'quantity_' + rowData.id}
                                disabled={formData.status && formData.status === 'COMPLETED'}
                                value={rowData.quantity}
                                className={classNames({"p-inputtext-sm": true, "p-invalid": !!fieldErrors[key]})}
                                onValueChange={(e) => {
                                  const val = e.value;
                                  setItems(prev =>
                                    prev.map(item =>
                                      item.id === rowData.id ? { ...item, quantity: val } : item
                                    )
                                  );
                                  updateInventoryItemField(rowData.id, 'quantity', val);
                                }}
                              />
                              <div
                                style={{
                                  color: 'var(--red-500)',
                                  fontSize: '0.875rem',
                                  fontWeight: 400,
                                  marginTop: '4px',
                                  display: 'block',
                                  whiteSpace: 'normal',
                                  lineHeight: '1.4'
                                }}
                              >
                                {fieldErrors[key] || ''}
                              </div>
                            </div>
                          )
                        }}></Column>
                  <Column
                    body={actionBodyTemplate}
                    style={{width: '70px', textAlign: 'center'}}
                  />
                </DataTable>
              </Panel>
            </>
          }
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(PurchaseorderInventorydocumentFormComponent);
